<template>
  <div class="rules" v-bind:style="{ paddingBottom: $store.state.paddingBottom + 'px' }">

    <NavigationBar>
      <template v-slot:left>
        <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg">
      </template>
      <template v-slot:center>
        Teamtip
      </template>
    </NavigationBar>

    <div class="input-container" style="margin-top: 24px;">
      <div class="input-header" style="text-align: center">
        Danke für euren Support❤️
      </div>
      <div class="input-infotext">
        Die vergangenen Wochen waren für unser Teamtip-Team intensiv. Zum Start der WM haben wir einen deutlich größeren
        Ansturm auf Teamtip erlebt, als wir erwartet hatten. Ihr habt uns im wahrsten Sinne des Wortes die Bude
        eingerannt. Darüber freuen wir uns riesig und sind dankbar 🙏.
      </div>
      <div class="input-infotext">
        Gleichzeitig war dieser Ansturm für unser System ein großer Belastungstest, dem es an einigen Stellen nicht
        standgehalten konnte. Viele von euch konnten Tipps nicht sofort abgeben. Es gab lange Ladezeiten, Ergebnisse
        wurden verzögert oder teilweise gar nicht angezeigt. Manche Funktionen liefen schlicht nicht so, wie sie sollten
        und der Tippspaß blieb an vielen Stellen leider auf der Strecke.
      </div>
      <div class="input-infotext">
        <b>Das entspricht natürlich nicht unserem Anspruch.</b> Umso dankbarer sind wir allen, die uns Feedback gegeben,
        Fehler gemeldet und trotz allem weiter mit Teamtip getippt haben. Auch wenn die vielen schlechten App-Store
        Bewertungen weh tun, gehören auch sie zum Feedback dazu und haben uns geholfen die Fehler zu beseitigen.
      </div>
      <div class="input-infotext">
        <b>Was wir seitdem verbessert haben</b><br>
        Wir haben fast Tag und Nacht daran gearbeitet, Teamtip stabiler und schneller zu machen:
        <ul>
          <li>🚀 <b>Teamtip startet und lädt jetzt deutlich schneller</b> – egal ob beim Öffnen der App, beim Wechsel
            zwischen Seiten oder beim Abrufen von Ergebnissen.
          </li>
          <li>💪 <b>Wir haben die Stabilität deutlich verbessert,</b> damit Teamtip auch dann zuverlässig läuft, wenn
            besonders viele von euch gleichzeitig sehen wollen wo sie in der Tabelle stehen und wie es bei einem Spiel
            steht.
          </li>
          <li>⚙️ <b>Im Hintergrund haben wir unsere technische Infrastruktur umfassend modernisiert.</b> Dadurch werden
            Anfragen effizienter verarbeitet und Teamtip ist für zukünftige Großereignisse und neue Funktionen deutlich
            besser aufgestellt. Zudem haben wir die Datensicherheit verbessert und es wurden mögliche Sicherheitslücken
            geschlossen.
          </li>
        </ul>
      </div>
      <div class="input-infotext">
        <b>Und was wir in Zukunft noch mit euch vorhaben:</b><br>
        Die WM endet. Teamtip natürlich nicht. Wir arbeiten bereits an den nächsten Verbesserungen, damit eure nächste Bundesliga-, Champions-League- oder EM-Tipprunde noch besser wird.
        Und die Vorfreude auf die neue Saison hat schon begonnen: Die Spielpläne sind veröffentlicht und ihr könnt ab sofort wieder Tipprunden für die Bundesliga, die 2. Bundesliga, die Premier League und viele weitere Wettbewerbe erstellen. Auch unsere öffentlichen Community-Tipprunden sind bereits live – dort könnt ihr gemeinsam mit anderen Fußballfans um tolle Preise mittippen.
      </div>
      <div class="input-infotext">
        Teamtip ist von Fußballfans für Fußballfans und es soll für euch weiterhin kostenfrei bleiben. Euer Feedback hilft uns dabei, die App jeden Tag ein Stück besser zu machen. Danke, dass ihr diesen Weg auch weiter mit uns geht. Und wenn ihr wieder happy mit dem Tipperlebnis seid und Lust habt, freuen wir uns auch über eine gute Bewertung im App Store. Damit würdet ihr uns sehr helfen 🙏.
      </div>
      <div class="input-infotext">
        Euer Teamtip-Team
      </div>
      <div class="input-infotext">
        <img v-if="this.isSPMUser()" src="../assets/images/teamtip/spm_team.jpg" style="width: 100%;">
      </div>
      <div class="input-infotext">
      </div>
    </div>
    
    
    <div style="padding-top: 64px;"></div>
    
  </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar'

export default {
  name: 'BetgameInfo',
  components: { NavigationBar },
  created () {
    if (!this.isSPMUser()) {
      this.$router.push('/home')
    }
  },
  computed: {
    userlang () {
      return this.$store.state.language
    },
    packageVersion () {
      return process.env.PACKAGE_VERSION || '0'
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'home' }).catch(err => {
      })
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
